<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid text-start">
        مدیریت جلسات:
        <span class="fs-3">
          {{ productName }}
        </span>

        <div class="accordion" id="accordionExample">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                درج کلی جلسات &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </button>
            </h2>
            <div
              id="collapseOne"
              class="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div v-show="errorMulti" class="alert alert-danger">
                {{ errorMulti }}
              </div>
              <div class="accordion-body">
                <div class="row mt-3">
                  <div class="col-md-4 col-sm-6 col-xs-12">
                    <div class="mb-3">
                      <label for="name">انتخاب روزهای هفته</label>
                      <Multiselect
                        v-model="formData.days"
                        mode="tags"
                        :searchable="true"
                        :createTag="true"
                        :options="[
                          { value: 'Saturday', label: 'شنبه' },
                          { value: 'Sunday', label: 'یکشنبه' },
                          { value: 'Monday', label: 'دوشنبه' },
                          { value: 'Tuesday', label: 'سه‌شنبه' },
                          { value: 'Wednesday', label: 'چهارشنبه' },
                          { value: 'Thursday', label: 'پنج‌شنبه' },
                          { value: 'Friday', label: 'جمعه' },
                        ]"
                      />
                    </div>
                  </div>

                  <div class="col-md-4 col-sm-6 col-xs-12">
                    <div class="mb-3">
                      <label for="name"> تاریخ شروع *</label>
                      <DatePicker
                        id="from_date"
                        name="from_date"
                        v-model="formData.from_date"
                      />
                    </div>
                  </div>

                  <div class="col-md-4 col-sm-6 col-xs-12">
                    <div class="mb-3">
                      <label for="to_date"> تاریخ پایان *</label>
                      <DatePicker
                        id="to_date"
                        name="to_date"
                        v-model="formData.to_date"
                      />
                    </div>
                  </div>

                  <div class="col-md-4 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="time"
                        class="form-control"
                        placeholder="از ساعت"
                        v-model="formData.from_time"
                      />
                      <label for="name">از ساعت *</label>
                    </div>
                  </div>

                  <div class="col-md-4 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="time"
                        class="form-control"
                        placeholder="تا ساعت"
                        v-model="formData.to_time"
                      />
                      <label for="name">تا ساعت *</label>
                    </div>
                  </div>

                  <div class="col-md-4 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="قیمت"
                        v-model="formData.per_price"
                        :keyup="monize()"
                      />
                      <label for="name"> قیمت *</label>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <select
                        class="form-control"
                        v-model="formData.single_purchase"
                      >
                        <option value="1">بله</option>
                        <option value="0">خیر</option>
                      </select>
                      <label> قابلیت فروش تکی </label>
                    </div>
                  </div>
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <a class="btn btn-primary" @click="insertMultiSessions()">
                      ثبت جلسات
                    </a>
                    <span
                      v-show="showSpin"
                      class="fas fa-spinner fa-spin mt-3"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingTwo">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                درج تک جلسه
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </button>
            </h2>
            <div
              id="collapseTwo"
              class="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample"
            >
              <div class="accordion-body">
                <div v-show="errorSingle" class="alert alert-danger">
                  {{ errorSingle }}
                </div>
                <div class="row mt-3">
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="mb-3">
                      <label for="name"> تاریخ شروع *</label>
                      <DatePicker v-model="singleSessionData.date" />
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="time"
                        class="form-control"
                        placeholder="از ساعت"
                        v-model="singleSessionData.from_time"
                      />
                      <label for="name">از ساعت *</label>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="time"
                        class="form-control"
                        placeholder="تا ساعت"
                        v-model="singleSessionData.to_time"
                      />
                      <label for="name">تا ساعت *</label>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="قیمت"
                        v-model="singleSessionData.price"
                        :keyup="monize()"
                      />
                      <label for="name"> قیمت *</label>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="نام جلسه"
                        v-model="singleSessionData.name"
                      />
                      <label for="name"> نام (می‌تواند خالی باشد) </label>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <select
                        class="form-control"
                        v-model="singleSessionData.video_session_type"
                      >
                        <option value="offline">آفلاین</option>
                        <option value="online">آنلاین</option>
                      </select>
                      <label>نوع </label>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <select
                        class="form-control"
                        v-model="singleSessionData.is_hidden"
                      >
                        <option value="0">قابل نمایش</option>
                        <option value="1">پنهان</option>
                      </select>
                      <label> نمایش </label>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <select
                        class="form-control"
                        v-model="singleSessionData.extraordinary"
                      >
                        <option value="0">خیر</option>
                        <option value="1">بله</option>
                      </select>
                      <label> فوق العاده </label>
                    </div>
                  </div>
                  <div class="col-md-9 col-sm-12 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="قیمت"
                        id="video_link"
                        v-model="singleSessionData.video_link"
                      />
                      <label for="video_link">لینک ویدیو</label>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <select
                        class="form-control"
                        v-model="singleSessionData.single_purchase"
                      >
                        <option value="1">بله</option>
                        <option value="0">خیر</option>
                      </select>
                      <label> قابلیت فروش تکی </label>
                    </div>
                  </div>

                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <a class="btn btn-primary" @click="insertSingleSession()">
                      ذخیره تک جلسه
                    </a>
                    <span
                      v-show="showSpin"
                      class="fas fa-spinner fa-spin mt-3"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingThree">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                درج از دیگر محصولات
              </button>
            </h2>
            <div
              id="collapseThree"
              class="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#accordionExample"
            >
              <div class="accordion-body">
                <div v-show="errorOther" class="alert alert-danger">
                  {{ errorOther }}
                </div>
                <div class="row mt-3">
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <label>انتخاب محصول</label>
                    <Select2
                      class="mt-2"
                      :options="productList"
                      :settings="{ placeholder: 'انتخاب محصول' }"
                      @select="getSelectedProductVideosSessionsList($event)"
                    />
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <label>انتخاب جلسه</label>
                    <Select2
                      class="mt-2"
                      :options="selectedProductVideosSessionsList"
                      :settings="{ placeholder: 'انتخاب جلسه' }"
                      v-model="otherSessionData.selectedProductVideosSession"
                    />
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="قیمت"
                        v-model="otherSessionData.price"
                        :keyup="monize()"
                      />
                      <label for="name"> قیمت </label>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="نام جلسه"
                        v-model="otherSessionData.name"
                      />
                      <label for="name"> نام (می‌تواند خالی باشد) </label>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <select
                        class="form-control"
                        v-model="otherSessionData.is_hidden"
                      >
                        <option value="0">قابل نمایش</option>
                        <option value="1">پنهان</option>
                      </select>
                      <label> نمایش </label>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <select
                        class="form-control"
                        v-model="otherSessionData.extraordinary"
                      >
                        <option value="0">خیر</option>
                        <option value="1">بله</option>
                      </select>
                      <label> فوق العاده </label>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-floating mb-3">
                      <select
                        class="form-control"
                        v-model="otherSessionData.single_purchase"
                      >
                        <option value="1">بله</option>
                        <option value="0">خیر</option>
                      </select>
                      <label> قابلیت فروش تکی </label>
                    </div>
                  </div>
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <a class="btn btn-primary" @click="insertOtherSession()">
                      ذخیره
                    </a>
                    <span
                      v-show="showSpin"
                      class="fas fa-spinner fa-spin mt-3"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="caption-top table table-hover table-striped">
            <caption>
              {{
                this.$route.meta.title
              }}
              {{
                productName
              }}
            </caption>
            <thead class="table-dark">
              <tr>
                <th scope="col">ردیف</th>
                <th scope="col">نام</th>
                <th scope="col">قیمت - تومان</th>
                <th scope="col">شروع</th>
                <th scope="col">ساعت شروع</th>
                <th scope="col">ساعت پایان</th>
                <th scope="col">off/on</th>
                <th scope="col">نمایش</th>
                <th scope="col">وضعیت</th>
                <th scope="col">فروش‌تکی</th>
                <th scope="col">شناسه</th>
                <th scope="col">مشاهده</th>
                <th scope="col">ویرایش</th>
                <th scope="col">حذف</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sesssionsList" :key="item.id">
                <th style="width: 3%" scope="row">
                  {{ index + 1 }}
                </th>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ this.utils.monize(item.price) }}
                </td>
                <td>
                  {{ jmoment(item.start_date).format("jYYYY/jMM/jDD") }}
                </td>
                <td>
                  {{ item.start_time }}
                </td>
                <td>
                  {{ item.end_time }}
                </td>
                <td>
                  {{ item.video_session_type }}
                </td>
                <td>
                  <span v-if="item.is_hidden == 0">
                    <span class="fas fa-check text-success"></span>
                  </span>
                  <span v-else>
                    <i class="fas fa-window-close text-danger"></i>
                  </span>
                </td>
                <td>
                  <span v-if="item.extraordinary == 0"> --- </span>
                  <span v-else class="text-danger small"> فوق العاده </span>
                </td>
                <td>
                  <span
                    v-if="item.single_purchase == 1"
                    class="fas fa-check"
                  ></span>
                  <span v-else>--</span>
                </td>
                <td style="width: 3%">
                  {{ item.id }}
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'AdminVideoSession',
                      params: {
                        videoSessionId: item.id,
                        productId: formData.products_id,
                      },
                    }"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="fas fa-eye"></i>
                    <span>مشاهده </span>
                  </router-link>
                </td>
                <td>
                  <a class="btn btn-success btn-sm" @click="openModal(item.id)">
                    <i class="fas fa-edit"></i>
                    ویرایش
                  </a>
                </td>
                <td>
                  <a class="btn btn-sm btn-danger" @click="deleteItem(item.id)">
                    <i class="fas fa-trash"></i>
                    حذف
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="lastPage > 1"
          class="d-flex justify-content-center bd-highlight mb-3"
        >
          <span
            v-if="showPreviusSpin"
            class="fas fa-spinner fa-spin mt-3"
          ></span>
          <a
            :disabled="currentPage > 1"
            :class="
              'btn btn-primary btn-sm m-1 ' +
              (currentPage > 1 ? '' : 'disabled')
            "
            @click="previusPage()"
          >
            قبلی
          </a>
          <select class="m-1 p-1" @change="changePage($event)">
            <option
              v-for="index in this.lastPage"
              :key="index"
              :selected="index == this.currentPage"
            >
              {{ index }}
            </option>
          </select>
          <a
            :disabled="currentPage != lastPage"
            :class="
              'btn btn-primary btn-sm m-1 ' +
              (currentPage != lastPage ? '' : 'disabled')
            "
            @click="nextPage()"
          >
            بعدی
          </a>
          <span v-if="showNextSpin" class="fas fa-spinner fa-spin mt-3"></span>
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
  <!-- /#wrapper -->
  <div
    class="modal fade"
    id="videoModal"
    tabindex="-1"
    aria-labelledby="videoModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="videoModalLabel">.ویرایش جلسه</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <EditProductDetailVideo
            v-if="editProductDetailVideoId"
            :productDetailVideoId="editProductDetailVideoId"
            :page="Number(currentPage)"
            :files="productFiles"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidemenu from "../components/TheSidemenu";
import TheTopmenu from "../components/TheTopmenu";
import ArefApi from "../libs/api.js";
import utils from "../libs/utils.js";
import jmoment from "moment-jalaali";

import Multiselect from "@vueform/multiselect";
import DatePicker from "vue3-persian-datepicker";
import "vue3-persian-datepicker/dist/datepicker.min.css";
import Select2 from "vue3-select2-component";
import EditProductDetailVideo from "./EditProductDetailVideo";
import * as Bootstrap from "bootstrap";

export default {
  name: "Sessions",
  setup() {
    return {
      DatePicker,
    };
  },
  created: function () {
    this.jmoment = jmoment;
    this.utils = new utils();
    this.arefApi = new ArefApi(this);
  },
  components: {
    TheSidemenu,
    TheTopmenu,
    Multiselect,
    Select2,
    EditProductDetailVideo,
  },
  data() {
    return {
      sesssionsList: null,
      currentPage: this.$route.params.page ? this.$route.params.page : 1,
      lastPage: null,
      showPreviusSpin: false,
      showNextSpin: false,
      showAllSessions: false,
      formData: {
        days: null,
        from_date: null,
        to_date: null,
        from_time: null,
        to_time: null,
        per_price: null,
        products_id: this.$route.params.productId
          ? this.$route.params.productId
          : null,
        single_purchase: 1,
      },
      singleSessionData: {
        date: null,
        from_time: null,
        to_time: null,
        is_hidden: 0,
        extraordinary: 0,
        price: 0,
        name: null,
        products_id: this.$route.params.productId
          ? this.$route.params.productId
          : null,
        video_session_type: "offline",
        video_link: null,
        single_purchase: 1,
      },
      productName: null,
      productFiles: [],
      errorMulti: null,
      errorSingle: null,
      errorOther: null,
      showSpin: null,
      productList: null,
      selectedProductVideosSessionsList: [],

      otherSessionData: {
        price: 0,
        selectedProductVideosSession: null,
        is_hidden: 0,
        extraordinary: 0,
        name: null,
        products_id: this.$route.params.productId
          ? this.$route.params.productId
          : null,
        single_purchase: 1,
      },
      editProductDetailVideoId: -1,
    };
  },
  methods: {
    async getProductName() {
      try {
        let res = await this.arefApi.getProduct(this.formData.products_id);
        this.productName = res.data.name;
        this.productFiles = res.data.files;
      } catch {
        this.productName = "محصول پیدا نشد";
      }
    },
    insertMultiSessions() {
      if (!this.validateMultiSessions()) {
        return false;
      }
      this.showSpin = true;

      this.formData.per_price = Number(
        this.formData.per_price.replace(/,/g, "")
      );
      this.formData.from_date = jmoment(
        this.formData.from_date,
        "jYYYY/jM/jD"
      ).format("YYYY-M-D");
      this.formData.to_date = jmoment(
        this.formData.to_date,
        "jYYYY/jM/jD"
      ).format("YYYY-M-D");

      this.formData.single_purchase = Number(this.formData.single_purchase);

      this.arefApi
        .insertVideos(this.formData)
        .then(() => {
          this.utils.showSuccess(this);
          this.getProductVideoSessions(this.currentPage);
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.showSpin = false;
        });
    },
    monize() {
      this.formData.per_price = this.utils.monize(this.formData.per_price);
      this.singleSessionData.price = this.utils.monize(
        this.singleSessionData.price
      );
      this.otherSessionData.price = this.utils.monize(
        this.otherSessionData.price
      );
    },
    validateMultiSessions() {
      this.errorMulti = null;
      if (!this.formData.days || this.formData.days.length == 0) {
        this.errorMulti = "حداقل یک روز از هفته باید انتخاب شود";
        return false;
      }

      if (!this.formData.from_date) {
        this.errorMulti = "تاریخ شروع جلسات را وارد کنید";
        return false;
      }

      if (!this.formData.to_date) {
        this.errorMulti = "تاریخ پایان جلسات را وارد کنید";
        return false;
      }

      if (!this.formData.from_time) {
        this.errorMulti = "ساعت شروع جلسات را وارد کنید";
        return false;
      }

      if (!this.formData.to_time) {
        this.errorMulti = "ساعت پایان جلسات را وارد کنید";
        return false;
      }

      const from_date = jmoment(this.formData.from_date, "jYYYY/jM/jD").unix();
      const to_date = jmoment(this.formData.to_date, "jYYYY/jM/jD").unix();
      if (from_date >= to_date) {
        this.errorMulti = "تاریخ شروع و پایان را صحیح وارد نمایید";
        return false;
      }

      const from_time = Date.parse("20 Aug 2021 " + this.formData.from_time);
      const to_time = Date.parse("20 Aug 2021 " + this.formData.to_time);
      if (from_time >= to_time) {
        this.errorMulti = "ساعت شروع و پایان را صحیح وارد نمایید";
        return false;
      }

      return true;
    },
    insertSingleSession() {
      if (!this.validateSingleSessions()) {
        return;
      }
      this.singleSessionData.price = Number(
        this.singleSessionData.price.toString().replace(/,/g, "")
      );
      this.singleSessionData.is_hidden = Number(
        this.singleSessionData.is_hidden
      );
      this.singleSessionData.extraordinary = Number(
        this.singleSessionData.extraordinary
      );
      this.singleSessionData.products_id = Number(
        this.singleSessionData.products_id
      );

      this.singleSessionData.single_purchase = Number(
        this.singleSessionData.single_purchase
      );

      this.singleSessionData.date = jmoment(
        this.singleSessionData.date,
        "jYYYY/jM/jD"
      ).format("YYYY-M-D");

      this.arefApi
        .insertSingleProduct(this.singleSessionData)
        .then(() => {
          this.utils.showSuccess(this);
          this.getProductVideoSessions(this.currentPage);
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    validateSingleSessions() {
      this.errorSingle = null;

      if (!this.singleSessionData.date) {
        this.errorSingle = "تاریخ جلسه را وارد کنید";
        return false;
      }

      if (!this.singleSessionData.from_time) {
        this.errorSingle = "ساعت شروع جلسه را وارد کنید";
        return false;
      }

      if (!this.singleSessionData.to_time) {
        this.errorSingle = "ساعت پایان جلسه را وارد کنید";
        return false;
      }

      const from_time = Date.parse(
        "20 Aug 2021 " + this.singleSessionData.from_time
      );
      const to_time = Date.parse(
        "20 Aug 2021 " + this.singleSessionData.to_time
      );
      if (from_time >= to_time) {
        this.errorSingle = "ساعت شروع و پایان را صحیح وارد نمایید";
        return false;
      }

      if (
        Number(this.singleSessionData.extraordinary) == 1 &&
        !this.singleSessionData.name
      ) {
        this.errorSingle =
          "چون جلسه فوق العاده تعریف شده است حتما نام آن را تعیین کنید";
        return false;
      }

      return true;
    },
    insertOtherSession() {
      this.errorOther = null;
      if (!this.otherSessionData.selectedProductVideosSession) {
        this.errorOther = "لطفا جلسه مورد نظر را انتخاب فرمایید";
        return false;
      }
      this.otherSessionData.price = Number(
        this.otherSessionData.price.toString().replace(/,/g, "")
      );
      this.otherSessionData.is_hidden = Number(this.otherSessionData.is_hidden);
      this.otherSessionData.extraordinary = Number(
        this.otherSessionData.extraordinary
      );
      this.otherSessionData.products_id = Number(
        this.otherSessionData.products_id
      );
      this.otherSessionData.product_detail_videos_id = Number(
        this.otherSessionData.selectedProductVideosSession
      );

      this.otherSessionData.single_purchase = Number(
        this.otherSessionData.single_purchase
      );

      this.arefApi
        .assignVideoToProduct(this.otherSessionData)
        .then(() => {
          this.utils.showSuccess(this);
          this.getProductVideoSessions(this.currentPage);
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    async getProductVideoSessions(page) {
      if (!this.formData.products_id) {
        return;
      }
      this.arefApi
        .getProductVideoSessions(
          this.formData.products_id,
          page,
          this.showAllSessions
        )
        .then((sesssionsList) => {
          this.sesssionsList = sesssionsList.data;
          this.currentPage = sesssionsList.meta.current_page;
          this.lastPage = sesssionsList.meta.last_page;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    async getproductList() {
      let out = [];
      try {
        const res = await this.arefApi.getProductsIndex(1, true);
        for (let i in res.data) {
          if (res.data[i].id == this.formData.products_id) {
            continue;
          }
          out.push({
            id: res.data[i].id,
            text: res.data[i].name,
          });
        }
      } catch (e) {
        console.log(e);
      }
      return out;
    },
    getSelectedProductVideosSessionsList({ id }) {
      this.errorOther = null;
      this.selectedProductVideosSessionsList = [];
      this.arefApi
        .getProductVideoSessions(id, 1, true)
        .then((resp) => {
          for (let i in resp.data) {
            this.selectedProductVideosSessionsList.push({
              id: resp.data[i].id,
              text:
                resp.data[i].name +
                " " +
                jmoment(resp.data[i].start_date).format("jYYYY/jM/jD") +
                " " +
                resp.data[i].start_time +
                "-" +
                resp.data[i].end_time,
            });
          }
        })
        .catch(() => {
          this.errorOther = "نمایش جلسات زیر مجموعه محصول با خطا مواجه شد";
        });
    },
    openModal(productDetailVideoId) {
      this.editProductDetailVideoId = productDetailVideoId;
      var myModal = new Bootstrap.Modal(document.getElementById("videoModal"), {
        keyboard: true,
      });
      myModal.toggle();
    },
    nextPage: async function () {
      this.showNextSpin = true;
      this.currentPage++;
      this.$router.push(
        `/admin/sessions/${this.formData.products_id}/${this.currentPage}`
      );
      await this.getProductVideoSessions(this.currentPage);
      this.showNextSpin = false;
    },
    previusPage: async function () {
      this.showPreviusSpin = true;
      this.currentPage--;
      this.$router.push(
        `/admin/sessions/${this.formData.products_id}/${this.currentPage}`
      );
      await this.getProductVideoSessions(this.currentPage);
      this.showPreviusSpin = false;
    },
    changePage: function (event) {
      this.$router.push(
        `/admin/sessions/${this.formData.products_id}/${event.target.value}`
      );
      this.getProductVideoSessions(event.target.value);
    },
    deleteItem: function (productDetailVideoId) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .deleteProductDetailVideo(productDetailVideoId)
              .then(() => {
                this.$swal
                  .fire({
                    title: ``,
                    text: `حذف با موفقیت انجام شد`,
                    icon: "success",
                  })
                  .then(() => {
                    this.getProductVideoSessions(this.currentPage);
                  });
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
  },
  async mounted() {
    if (!this.formData.products_id) {
      this.$swal
        .fire({
          title: "خطا!",
          text: `محصول پیدا نشد`,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        })
        .then(() => {
          return this.$router.push({ name: "ListProducts" });
        });
    }
    this.getProductName();
    this.getProductVideoSessions(this.currentPage);
    this.productList = await this.getproductList();
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style>
.select2-container--default {
  min-width: 300px;
  max-width: 500px;
}
</style>
